.selectContainer {
    max-width: 300px;
}

.filterContainer {
    display: flex;
    align-items: flex-end;
    gap: 40px;
}
